<template>
	<div class="class-page">
		<!-- 顶部：标题 + 返回 -->
		<div class="top-bar">
			<h2>{{courseName}}</h2>
			<button @click="$router.back()" class="exit-btn">返回</button>
		</div>

		<div class="right-panel full-chat">
			<div class="chat-header">
				<h3>📝 {{courseName}}--AI记录</h3>
			</div>
			<div class="chat-content" ref="chatContent">
				<div v-for="(msg, idx) in chatList" :key="idx" class="msg-item" :class="msg.role">
					<div class="avatar">
						{{ msg.role === 'student' ? '👨‍🎓' : (msg.role === 'ai' ? '🤖' : '👨‍🏫') }}
					</div>
					<div class="msg-content">
						<div class="msg-time">{{ formatTime(msg.time) }}</div>
						<div v-html="msg.content"></div>
					</div>
				</div>

				<div v-if="chatList.length === 0" class="empty-tip">暂无聊天记录</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			classInfo: {},
			chatList: [],
			courseClassId: '',
			schoolId: localStorage.getItem('orgId'),
			studentId: localStorage.getItem('userId'),
			courseName:'',
			login:null,
		};
	},
	created() {
		this.courseClassId = this.$route.query.courseClassId;
		this.courseName = this.$route.query.courseName;
		this.loginOpen('历史数据加载中...')
		this.loadHistoryChat();
	},
	methods: {
		loginOpen(text) {
			this.requestCount = 0
			this.login = this.$loading({
				lock: true,
				text: text,
				zIndex: 100001,
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
		// 只加载历史消息
		async loadHistoryChat() {
			
			try {
				const res = await this.API.get(this.API.school.getWithRoleList, {
					schoolId: this.schoolId,
					courseClassId: this.courseClassId,
					studentId: this.studentId
				});
				if (res.data.code && res.data.data.length > 0) {
					this.chatList = res.data.data.map(item => ({
						role: item.role,
						content: item.content,
						time: item.createTime || Date.now(),
					}));
				}
			} catch (e) {
				console.error("加载历史记录失败", e);
			} finally{
				this.login.close()
			}
		},

		// 时间格式化
		formatTime(timestamp) {
			if (!timestamp) return '';
			const date = new Date(timestamp);
			const y = date.getFullYear();
			const m = String(date.getMonth() + 1).padStart(2, '0');
			const d = String(date.getDate()).padStart(2, '0');
			const h = String(date.getHours()).padStart(2, '0');
			const min = String(date.getMinutes()).padStart(2, '0');
			return `${y}-${m}-${d} ${h}:${min}`;
		},
	}
};
</script>

<style scoped>
	.class-page {
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: column;
		background: #f5faff;
		box-sizing: border-box;
	}

	.top-bar {
		background: #2d8cf0;
		color: #fff;
		padding: 14px 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-shrink: 0;
	}

	.exit-btn {
		background: #ff4d4f;
		color: #fff;
		border: none;
		padding: 8px 14px;
		border-radius: 6px;
		cursor: pointer;
	}

	.right-panel.full-chat {
		flex: 1;
		background: #fff;
		padding: 20px;
		display: flex;
		flex-direction: column;
		overflow: hidden;
	}

	.chat-header {
		border-bottom: 1px solid #eee;
		padding-bottom: 10px;
		margin-bottom: 10px;
		flex-shrink: 0;
	}

	.chat-header h3 {
		font-size: 18px;
		color: #2d8cf0;
	}

	.chat-content {
		flex: 1;
		overflow-y: auto;
		padding: 10px;
	}

	.msg-item {
		display: flex;
		margin: 10px 0;
		max-width: 80%;
	}

	.msg-item.student {
		flex-direction: row-reverse;
		margin-left: auto;
	}

	.msg-item.teacher {
		flex-direction: row;
		margin-right: auto;
	}

	.avatar {
		font-size: 20px;
		margin: 0 10px;
	}

	.msg-content {
		background: #f1f1f1;
		padding: 10px 14px;
		border-radius: 12px;
		font-size: 16px;
		line-height: 1.5;
		word-break: break-all;
		white-space: pre-wrap;
	}

	.msg-time {
		font-size: 12px;
		color: #999;
		margin-bottom: 6px;
	}

	.msg-item.student .msg-content {
		background: #2d8cf0;
		color: #fff;
	}

	.msg-item.teacher .msg-content {
		background: #ff7d00;
		color: #fff;
	}

	.msg-item.ai .msg-content {
		background: #f8f9fa;
		color: #333;
	}

	.empty-tip {
		text-align: center;
		padding: 40px 0;
		color: #999;
		font-size: 16px;
	}
</style>